module.exports = __webpack_public_path__ + "img/5b15d92.png";